import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Auth from './pages/Auth';
import LandingPage from './pages/LandingPage';
import TermsPage from './pages/TermsPage';
import PrivacyPage from './pages/PrivacyPage';
import AccountPage from './pages/AccountPage';
import LeagueSelector from './pages/LeagueSelector';
import LeaguePage from './pages/LeaguePage';
import LeagueManagePage from './pages/LeagueManagePage';
import LeagueDirectory from './pages/LeagueDirectory';
import JoinLeague from './pages/JoinLeague';
import AdminPage from './pages/AdminPage';
import BlogPage from './pages/BlogPage';
import BlogPostPage from './pages/BlogPostPage';
import AdminBlogPage from './pages/AdminBlogPage';

function AppRoutes() {
  const { currentUser, userProfile } = useAuth();
  const isDark = !!(currentUser && userProfile?.darkMode);

  return (
    <div className={isDark ? 'dark' : ''} style={{ minHeight: '100vh', background: 'var(--bg)' }}>
      <Routes>
        {/* Public landing page */}
        <Route
          path="/"
          element={currentUser ? <Navigate to="/leagues" replace /> : <LandingPage />}
        />

        {/* Auth — sign in / sign up */}
        <Route
          path="/login"
          element={currentUser ? <Navigate to="/leagues" replace /> : <Auth />}
        />

        {/* Static pages */}
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />

        {/* Blog — public */}
        <Route path="/blog" element={<BlogPage />} />
        <Route path="/blog/:slug" element={<BlogPostPage />} />

        {/* Account */}
        <Route
          path="/account"
          element={currentUser ? <AccountPage /> : <Navigate to="/login" replace />}
        />

        {/* Invite link — works logged-in or logged-out */}
        <Route path="/join/:inviteCode" element={<JoinLeague />} />

        {/* League selector */}
        <Route
          path="/leagues"
          element={currentUser ? <LeagueSelector /> : <Navigate to="/login" replace />}
        />

        {/* Public league directory */}
        <Route
          path="/directory"
          element={currentUser ? <LeagueDirectory /> : <Navigate to="/login" replace />}
        />

        {/* Commissioner manage screen — must come before the wildcard league route */}
        <Route
          path="/league/:leagueId/manage"
          element={currentUser ? <LeagueManagePage /> : <Navigate to="/login" replace />}
        />

        {/* Individual league — tabs built in Phases 11-14 */}
        <Route
          path="/league/:leagueId/*"
          element={currentUser ? <LeaguePage /> : <Navigate to="/login" replace />}
        />

        {/* Admin console */}
        <Route
          path="/admin"
          element={currentUser ? <AdminPage /> : <Navigate to="/login" replace />}
        />

        {/* Admin blog editor */}
        <Route
          path="/admin/blog"
          element={currentUser ? <AdminBlogPage /> : <Navigate to="/login" replace />}
        />
        <Route
          path="/admin/blog/:slug"
          element={currentUser ? <AdminBlogPage /> : <Navigate to="/login" replace />}
        />

        {/* Catch-all */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </div>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <Router>
        <AppRoutes />
      </Router>
    </AuthProvider>
  );
}
